import { Coordinate } from "game-common/models"

export const clamp = (num: number, min: number, max: number) => Math.min(Math.max(num, min), max)
export const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

// How far out the move stick has to be pushed to read as a sprint, and how much faster that is.
// The threshold is deliberately short of 1.0: a thumb held at the rim wanders, and a sprint that
// dropped out every time it wandered a pixel inwards would feel broken rather than fast.
export const SPRINT_POWER = 0.9
export const SPRINT_MULTIPLIER = 1.6

/**
 * The movement intent for a joystick pushed `power` (0..1) of the way out in `vector`'s direction.
 *
 * Pushing the stick all the way to the rim is a sprint. The stick already reports its travel, so
 * this costs no second control and no second thumb: steering sits below the threshold, and
 * committing a direction all the way IS the ask for speed.
 *
 * Scaling the vector is the whole mechanic. applyInput moves by speed2 * press_time on both sides
 * (it lives in game-common) and the server takes the client's speed2 as given, so a longer vector
 * predicts and resolves identically -- no protocol change, and nothing for reconciliation to fight.
 * It stays even across all eight directions too, because applyInput already shortens press_time on
 * the diagonals.
 *
 * Returns a NEW object when sprinting: callers pass in shared direction constants, and scaling one
 * of those in place would leave that direction sprinting for good.
 */
export const sprintScaledIntent = (vector: Coordinate, power: number): Coordinate =>
    power >= SPRINT_POWER ? { x: vector.x * SPRINT_MULTIPLIER, y: vector.y * SPRINT_MULTIPLIER } : vector

export const SCALER = 1.3
export const getRandomColor = () => {
    const letters = "0123456789ABCDEF".split("")
    let color = "0x"
    for (var i = 0; i < 6; i++) {
        color += letters[Math.round(Math.random() * 15)]
    }
    return color
}

export const ScalingParams = {
    scale: SCALER,
    surfaceZoom: 2.0,
    viewportX: 7,
    viewportY: 5,
    // Extra world units revealed on each edge by the mobile canvas. Kept separate from
    // viewportX/Y, which also control the camera's fixed position and map-edge clamping.
    viewportPaddingX: 0,
    viewportPaddingY: 0,
}
